import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import { observer, inject } from "mobx-react";
import { faUser, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import {
	Page, Footer, Jumbotron, Card,
} from "../common";

export const HomePage = inject(({ rootStore }) => ({
	userStore: rootStore.userStore,
}))(
	observer(({ userStore, history }) => {
		const { isAuthenticated } = userStore;

		return (
			<Page footer={<Footer />}>
				<Jumbotron background="landing">
					<h1 className="welcome-header">Välkommen till SOLTAK Kundservice</h1>
				</Jumbotron>

				<Container className="center">
					<Row className="mb-5">
						{!isAuthenticated ? (
							<>
								<Col md={6}>
									<Card
										title="Privatpersoner, leverantörer och myndigheter"
										description="Möjlighet att lägga ärende till SOLTAK kundservice för privatpersoner, leverantörer och myndigheter"
										icon={null}
										onClick={() => history.push("/external")}
									/>
								</Col>
							</>
						) : (
							<>
								<Col md={6}>
									<Card
										title="Mina ärenden"
										description="Följ upp dina ärenden"
										icon={faUser}
										onClick={() => history.push("/issues")}
									/>
								</Col>
								<Col md={6}>
									<Card
										title="Registrera ärenden"
										description="Registrera ett nytt ärende"
										icon={faExclamationCircle}
										onClick={() => history.push("/category")}
									/>
								</Col>
							</>
						)}
					</Row>
				</Container>
			</Page>
		);
	}),
);
